import React, { Component } from "react";
import {connect} from "react-redux";
import "./Product.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Card from 'react-bootstrap/Card'
import getProducts from './../../_actions/productActions';
//display of list products 19/06/2023
import Utils from "../../_helpers/utils";
import tile from "./images/tile.svg";
import list from "./images/list.svg";

class ProductList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
	  view: "grid",
      isMobile:true,
    };
  }

	componentDidMount() {
		this.props.getProducts();
		//find diff of device
		if(Utils.isMobileDevice()) {
			this.setState({
			view: "grid",
			isMobile:true
			});  
		}
		else {
			this.setState({
			view: "list",
			isMobile:false
			});
		}
	}

    //change view of list
    changeView(view) {
		this.setState({view: view});    
	}
  routeChange(path) {
    this.props.history.push(path);
  }

  render() {
		return  <div className="Product card_list"> 
		{
		  this.props.product.map((item, index) => {
			if(item.id==this.props.match.params.id){
			  return ( 
				<div key={index}>
					<div className="module-header-step2 blue-light-card">
					<div className="back">
							<FontAwesomeIcon icon={ faArrowLeft } onClick={this.props.history.goBack} />
					</div>
					</div>
					<div className="menu-block">
					{
					this.state.isMobile ?
						<div className="arrow-set">
							<div className="col-10">
								<h4>{item.name}</h4>
							</div>
							<div className="col-2">
								{this.state.view === 'list'? <img alt="list" src={tile} className="custbrdr"  onClick={() => this.changeView('grid')} />: <img alt="grid" src={list} className="custbrdr"  onClick={() => this.changeView('list')}/> }
							</div>
						</div>
						:
						<h4>{item.name}</h4> 
					}
					</div><br /><br /><br />
					<div className="card_list">{ this.state.view === 'list'? this.renderCard(item.productList) : this.renderGrid(item.productList)}</div>
				</div>
			  )
			}
		  })
		}
    </div>
  }
  
  
  renderCard(productList){ //renderProduct
	return <div>
	{
		productList.map((c, i) =>{
			return (
			  <Card key={i} onClick={() => this.routeProductDetail(c)}>
				<Card.Body>
				  <div className="cardbody product">
					<img src={c.imageUrl} alt={c.name} />
					<h4 className="head">{c.name}</h4>
					<button className="download green-card">₹ {c.cost}</button>
				  </div>
				</Card.Body>
			  </Card>
			)
		})
	}
	</div>
  }
  
  //renderGrid
renderGrid(productList) {
	return  <div className="mobile_course_list"> 
	{
	  productList.map((c, i) => {
	  return (
		<div key={i} onClick={() => this.routeProductDetail(c)}>
			<div className="row">
			  <div className="col-12">
				<div className="course_box">
				  <div className="card">
					<img alt={c.name} src={c.imageUrl} className="img img-responsive" />
					<div className="head">
					  <p className="title"><strong>{c.name}</strong></p>
					  <button className="download green-card">₹ {c.cost}</button>
					</div>
				  </div> 
				</div>
			  </div> 
			</div>
		</div>
	  )
	  })
	}
	</div>
  }

routeProductDetail = (product) => {
    //console.log(JSON.stringify(card));
    this.props.history.push({
      pathname: '/ProductDetails',
      state: { product: product }});
  };

}

const mapStateToProps = state => ({
  product: state.product.product
});

const mapDispatchToProps = {
  getProducts: getProducts,
};


export default connect(mapStateToProps,mapDispatchToProps) (ProductList);
